
























import { Component, Vue } from "vue-property-decorator";
import BodyHead from "./BodyHead.vue";
import RecentCalcs from "./RecentCalcs.vue";
@Component({
    components: { BodyHead, RecentCalcs }
})
export default class Body extends Vue {
    get showPreviousCalculations(): boolean {
        if (process.env.NODE_ENV === "development") return true;
        return this.$store.direct.state.widget.showPreviousCalculations;
    }
    get showCalcs(): boolean {
        return this.$store.direct.state.showRecentCalc;
    }
    set showCalcs(val) {
        this.$store.state.showRecentCalc = val;
    }

    get step(){
        return this.$store.direct.state.insurance.step;
    }

    get widget() {
        return this.$store.direct.state.widget;
    }

    get showHead() {
        if (this.widget.hideStepsPanel)
            return false;

        return !this.$route.path.includes("stepper") && this.step < 4;
    }
}
